import ToIntIfInt from '@usas/ui-web/utils/ToIntIfInt';

// Only real errors get keys. UseForm counts keys to block submit.
export const ageRangeErrors = (formState) => {
  const errors = {};
  const minAge = ToIntIfInt(formState.minAge);
  const maxAge = ToIntIfInt(formState.maxAge);

  if (formState.minAge === '') {
    errors.minAge = 'Min Age is required';
  } else if (typeof minAge !== 'number') {
    errors.minAge = 'Min Age must be a whole number';
  } else if (minAge < 1 || minAge > 99) {
    errors.minAge = 'Min Age must be between 1 and 99';
  }

  if (formState.maxAge === '') {
    errors.maxAge = 'Max Age is required';
  } else if (typeof maxAge !== 'number') {
    errors.maxAge = 'Max Age must be a whole number';
  } else if (maxAge < 1 || maxAge > 99) {
    errors.maxAge = 'Max Age must be between 1 and 99';
  }

  if (!errors.minAge && !errors.maxAge && minAge > maxAge) {
    errors.minAge = 'Min Age cannot be greater than Max Age';
    errors.maxAge = 'Max Age cannot be less than Min Age';
  }

  return errors;
};
